import React from 'react';

import { Button, WrapperFlex } from '@unimed-fesp/components';

// #region Import Icons
import { MdSend, MdDelete, MdDone, MdErrorOutline } from 'react-icons/md';
import { BiListCheck } from 'react-icons/bi';
import { ImFloppyDisk } from 'react-icons/im';
// #endregion

import theme from '../../../styles/theme';

const FooterListaInativosAcoes = ({
  excluir,
  salvar,
  enviarDocumentos,
  erroProcessamento,
  processadaSucesso,
  conferirDocumentos,
  enviarProcessamento,
  enviarRevisaoDocumentos,
  disabledButtons,
}) => {
  return (
    <WrapperFlex marginTop={30} justifySpaceBetween fullWidth>
      {(excluir?.isRender || false) && (
        <Button
          disabled={disabledButtons}
          tipo="secondary"
          justifySpaceBetween
          font="16px unimed_slabregular"
          onClick={excluir?.onClick}
        >
          <MdDelete
            size={20}
            color={theme.greenDefault}
            style={{ marginRight: '5px' }}
          />
          excluir
        </Button>
      )}
      <WrapperFlex gap={20}>
        {(enviarProcessamento?.isRender || false) && (
          <Button
            disabled={disabledButtons}
            justifySpaceBetween
            font="16px unimed_slabregular"
            onClick={enviarProcessamento?.onClick}
          >
            <MdSend
              size={25}
              color={theme.white}
              style={{ marginRight: '5px' }}
            />
            enviar para processamento
          </Button>
        )}
        {(enviarRevisaoDocumentos?.isRender || false) && (
          <Button
            disabled={disabledButtons}
            justifySpaceBetween
            font="16px unimed_slabregular"
            onClick={enviarRevisaoDocumentos?.onClick}
          >
            <BiListCheck
              size={25}
              color={theme.white}
              style={{ marginRight: '5px' }}
            />
            enviar revisão de documentos
          </Button>
        )}
        {(conferirDocumentos?.isRender || false) && (
          <Button
            disabled={disabledButtons}
            justifySpaceBetween
            font="16px unimed_slabregular"
            onClick={conferirDocumentos?.onClick}
          >
            <MdDone
              size={20}
              color={theme.white}
              style={{ marginRight: '5px' }}
            />
            conferir documentos
          </Button>
        )}
        {(erroProcessamento?.isRender || false) && (
          <Button
            disabled={disabledButtons}
            tipo="secondary"
            justifySpaceBetween
            font="16px unimed_slabregular"
            onClick={erroProcessamento?.onClick}
          >
            <MdErrorOutline
              size={20}
              color={theme.greenDefault}
              style={{ marginRight: '5px' }}
            />
            erro de processamento
          </Button>
        )}
        {(processadaSucesso?.isRender || false) && (
          <Button
            disabled={disabledButtons}
            justifySpaceBetween
            font="16px unimed_slabregular"
            onClick={processadaSucesso?.onClick}
          >
            <MdDone
              size={20}
              color={theme.white}
              style={{ marginRight: '5px' }}
            />
            processada c/ sucesso
          </Button>
        )}

        {(enviarDocumentos?.isRender || false) && (
          <Button
            disabled={disabledButtons}
            justifySpaceBetween
            font="16px unimed_slabregular"
            onClick={enviarDocumentos?.onClick}
          >
            <MdSend
              size={20}
              color={theme.white}
              style={{ marginRight: '5px' }}
            />
            enviar documentos
          </Button>
        )}
        {(salvar?.isRender || false) && (
          <Button
            disabled={disabledButtons}
            justifySpaceBetween
            font="16px unimed_slabregular"
            onClick={salvar?.onClick}
          >
            <ImFloppyDisk
              size={20}
              color={theme.white}
              style={{ marginRight: '5px' }}
            />
            salvar
          </Button>
        )}
      </WrapperFlex>
    </WrapperFlex>
  );
};

export default FooterListaInativosAcoes;
